// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"6ced1746","383":"4f22b064","412":"18a1b7fa","416":"33bd0b79","580":"a3be95f3","738":"db6bfda9","807":"5df2c0fe"}[chunkId] + ".chunk.css";
};